import { createSingleUseObserver } from '../util/intersection-observer';

class Stats {
	constructor(el) {
		this.el = el;
		this.stats = this.el.querySelectorAll('.block-stats__stat-number');

		this.observeIntersection();
	}

	observeIntersection() {
		createSingleUseObserver(this.el, this.setEventHandlers, {});
	}

	setEventHandlers = () => {
		const offsetInterval = 500;

		this.stats.forEach((stat, index) => {
			const targetValue = parseInt(stat.textContent.replace(/\D/g, ''), 10);

			let currentValue = 0;
			const duration = 9000;
			const intervalTime = 48;
			const steps = duration / intervalTime;
			const increment = Math.ceil(targetValue / steps);

			const updateCounter = () => {
				currentValue += increment;
				if (currentValue > targetValue) {
					currentValue = targetValue;
				}
				stat.textContent = currentValue.toLocaleString();
			};

			setTimeout(() => {
				setInterval(updateCounter, intervalTime);
			}, index * offsetInterval);
		});
	};
}

export default Stats;
